export default "__VITE_ASSET__BcvlA8BE__"